<script setup lang="ts">
import type { NativeSelectOption } from '@shared/ui/fields'

import { NativeSelect } from '@shared/ui/fields'

defineOptions({
  name: 'ExtraRatesRateSelect',
})

defineProps<{
  name: string
  enabled: boolean
  value: number
  options: NativeSelectOption<number>[]
  disabledOptions: NativeSelectOption<number>[]
}>()

const emit = defineEmits<{
  change: [NativeSelectOption<number>]
}>()

const handleChange = (option: NativeSelectOption): void => {
  if (typeof option.value === 'number') {
    emit('change', option as NativeSelectOption<number>)
  }
}
</script>

<template>
  <NativeSelect
    v-if="enabled"
    :name="name"
    :options="options"
    :value="value"
    @change="handleChange"
  />
  <NativeSelect
    v-else
    :name="`${name}-disabled`"
    :options="disabledOptions"
    :value="0"
    disabled
  />
</template>
